import type {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import shieldImage from './media/shield.svg';

import styles from './Footer.module.scss';

const Footer: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.footer, props.className)}>
            {
                props.isLogoDisplayed &&
                <>
                    <img
                        className={styles.shieldImage}
                        src={shieldImage}
                        alt={'Firstpay logo'}
                    />
                    <span className={styles.text}>
                        Secure by Firstpay
                    </span>
                </>
            }
        </div>
    );
};

export default Footer;
